import { Signal } from "@lit-labs/signals";
import type { GetMySubscriptionTierResult } from "api-contracts/rpc/get-my-subscription-tier";
import type { ISubscriptionTierState } from "./types";

export class SubscriptionTierState implements ISubscriptionTierState {
  readonly tier = new Signal.State<GetMySubscriptionTierResult | null>(null);
  readonly loading = new Signal.State<boolean>(false);
}
